<div class="site_auth" [ngClass]="{ tutor_layout: userType === 'tutor' }">
  <div class="lt">
    <figure class="auth_logo" routerLink="/auth/login">
      <img [src]="assetsConst.logo" alt="Logo" />
    </figure>
    <div class="inner">
      @if (userType==='tutor') {
      <h1 class="hd_1_1">Inspire Learners, Share Knowledge</h1>
      <p>
        Become a Tutor to create test sets, help students, and monitor their
        progress with great tools.
      </p>
      }@else {
      <h1 class="hd_1_1">Master Your Exams with Confidence</h1>
      <p>
        Practice MCQs, track your progress, and unlock your potential with
        personalized learning paths.
      </p>
      }
    </div>
  </div>
  <div class="rt">
    <router-outlet class="form_mid" />
  </div>
</div>
